import React, { Component } from 'react'

export class Footer extends Component {
   render() {
      return (
         <div  className='text-center ' >
            <hr className='mt-4'></hr >
            <div className='d-flex dfadfad container mt-4 mb-4'>
               <h3 className='text-info'>Naim Biswas</h3>
               <h3 className='text-info'>CopyRight@2021 </h3>
            </div>
         </div>
      )
   }
}

export default Footer
